var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgNewRelease(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 512,
    height: 512,
    x: 0,
    y: 0,
    viewBox: "0 0 512 512",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M477.6 38.3c-.4-1.8-1.8-3.2-3.5-3.7-58.6-14.3-193.9 36.7-267.2 110-13.1 13-25 27.1-35.6 42.1-22.6-2-45.2-.3-64.5 8.1-54.4 23.9-70.2 86.4-74.7 113.2-.9 5.2 2.6 10.2 7.9 11.1.9.1 1.8.2 2.7.1l87.3-9.6c.1 6.6.5 13.2 1.2 19.7.4 4.5 2.5 8.8 5.7 12l33.8 33.7c3.2 3.2 7.5 5.3 12 5.7 6.5.7 13 1.1 19.6 1.2l-9.6 87.2c-.6 5.3 3.3 10.1 8.6 10.6.9.1 1.8.1 2.6-.1 26.8-4.3 89.4-20.1 113.2-74.5 8.4-19.3 10.1-41.8 8.2-64.3 15.1-10.6 29.2-22.6 42.2-35.6C441 232.1 491.7 99.8 477.6 38.3zM361.9 217.9c-18.7 18.7-49.1 18.8-67.8 0-18.8-18.7-18.8-49.1 0-67.9 18.7-18.8 49.1-18.8 67.9 0 18.7 18.8 18.7 49.2-.1 67.9z",
    fill: "#4466ef",
    opacity: 1,
    "data-original": "#000000"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M168.4 399.4c-5.5 5.5-14.3 7.6-24.9 9.5-23.8 4-44.8-16.5-40.5-40.5 1.6-9.1 6.5-21.9 9.5-24.9 1.7-1.7 1.8-4.5.1-6.2-1-1-2.3-1.5-3.7-1.3-13.3 1.6-25.7 7.7-35.1 17.1C50.2 376.7 48 464 48 464s87.4-2.2 110.9-25.8c9.5-9.5 15.5-21.8 17.1-35.2.4-4.1-4.7-6.6-7.6-3.6z",
    fill: "#4466ef",
    opacity: 1,
    "data-original": "#000000"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNewRelease);
export default __webpack_public_path__ + "static/media/NewRelease.cc4ecdf4bb2e1219491d02f6f1f25ed0.svg";
export { ForwardRef as ReactComponent };